// Checkout Forms
import { PHONE_NUMBER_UK_MOBILE } from 'checkout-forms/form/fields';

// Types
import { CollectorDetailsFormConfigProps } from './collectorDetails.types';

// Config
import CLICK_AND_COLLECT_DATES from './clickAndCollectDates';
import GIFT_MESSAGE from './giftMessage';
import GIFT_RECEIPT_CHECKBOX from './giftReceiptCheckbox';
import USER_EMAIL_ADDRESS from './userEmailAddress';
import getInternationalPhoneNumberConfig from '@utils/lazy/internationalPhoneNumberConfig';
import FulfilmentConfirmationAlert from '@components/fulfilment-confirmation-alert/FulfilmentConfirmationAlert';

export const COLLECTOR_DETAILS_FORM_ID = 'collectorDetailsForm';

export default function getCollectorDetailsFormConfig({
  containerClassName,
  dates,
  daysToShowPerPage,
  disabled,
  focusOnSelectedDayMessage,
  instruction,
  isCollectPlus,
  isGiftReceiptAvailable = false,
  isGiftReceiptSelected = false,
  isSinglePageCheckout,
  maxPagesToShow,
  selectedDay,
  selectedDayMessageClassName,
  selectedDayMessageTitle,
}: CollectorDetailsFormConfigProps) {
  const PHONE_NUMBER = getInternationalPhoneNumberConfig({
    instruction: 'A UK mobile number will allow us to send a text when the order is ready to collect',
  });

  const dayPicker = dates
    ? {
        ...CLICK_AND_COLLECT_DATES,
        required: !selectedDay,
        dates,
        daysToShowPerPage,
        maxPagesToShow,
        containerClassName,
        selectedDay,
        selectedDayMessageTitle,
        selectedDayMessageClassName,
        instruction,
        focusOnSelectedDayMessage,
        disabled,
      }
    : undefined;

  const PHONE_NUMBER_FIELD = isCollectPlus ? { ...PHONE_NUMBER_UK_MOBILE, instruction: '' } : PHONE_NUMBER;

  const giftFields = [];

  if (isGiftReceiptAvailable) {
    giftFields.push({
      ...GIFT_RECEIPT_CHECKBOX,
      checked: isGiftReceiptSelected,
      giftFormId: 'giftReceipt',
    });

    if (isGiftReceiptSelected) {
      giftFields.push({
        ...GIFT_MESSAGE,
        giftFormId: 'giftReceipt',
      });
    }
  }

  return {
    id: COLLECTOR_DETAILS_FORM_ID,
    fields: [
      dayPicker,
      USER_EMAIL_ADDRESS,
      PHONE_NUMBER_FIELD,
      ...giftFields,
      ...(isSinglePageCheckout
        ? [
            {
              extra: true,
              name: 'fulfilment-confirmation-alert',
              component: FulfilmentConfirmationAlert,
              props: { detailsType: 'collection', inForm: true },
            },
          ]
        : []),
    ],
    submitButton: isSinglePageCheckout ? 'Confirm collection details' : 'Continue to payment',
  };
}
